export default __webpack_public_path__ + "static/media/express.ea97b712.svg";